import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';

export default function DBABasicInfoComponent ({handleFormChange,selectedDba,handleInnerFormChange,accounts}: any) {
  const libraryData = useSelector(selectListItems)
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
           isDisabled
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedDba?.Name}
          />
         <InputContainer
         isDisabled
                          label="DBA Type"
                          labelField="Text"
                          list={libraryData?.result?.DBAType}
                          onValueChange={( newValue: any) => {
                            const valueData: any = newValue.map((option: any) => option?.value)
                            handleInnerFormChange(
                             valueData,
                             'Types'
                           )
                          }}
                          type="multiselect"
                           valueField="Text"
                          value={selectedDba?.Types}
                          
                      />
          <InputContainer
          isDisabled
                   label="Account Name"
                   labelField="Name"
                   list={accounts}
                   onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                       event.target.value,
                       'AccountId',
                     );
                   }}
                   optionName='Choose Account Name'
                   type="select"
                   value={selectedDba?.AccountId}
                   valueField="Id"
                   />
         <div className='col-span-full'>
        <InputContainer
       isDisabled
            label="Description"
            name="Description"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event,
                'Description',

              )
            }}
              type="rte"
            value={selectedDba?.Description}
        /></div>
        </div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}